import React, { PureComponent } from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import renderInputField from '../../../shared/components/form/renderInput';
import {withTranslation} from "react-i18next";
// import Collapse from '../../../shared/components/Collapse';

class OnesignalNotifications extends PureComponent {

  render() {
    const { handleSubmit, blog, t} = this.props;

    return (
      <Col xs={12} md={12} lg={12} xl={12}>
        <Card>
          <CardBody>
          <div className="card__title">
              <h5 className="bold-text">{t('settings.onesignal.title')}</h5>
              {/* <h5 className="subhead">Optional settings to make your blog look better when sharing on social media</h5> */}

            </div>
            <form className="form form--horizontal" onSubmit={handleSubmit}>

              <div className="form__form-group">
                <span className="form__form-group-label">{t('settings.onesignal.form_app_id.label')}:</span>
                <div className="form__form-group-field">
                  <Field
                    name="onesignal_app_id"
                    component={renderInputField}
                    type="text"
                    value={blog.link_facebook}
                  />
                </div>
              </div>

              <div className="form__form-group">
                <span className="form__form-group-label">{t('settings.onesignal.form_api_key.label')}:</span>
                <div className="form__form-group-field">
                  <Field
                    name="onesignal_api_key"
                    component={renderInputField}
                    type="text"
                    value={blog.link_facebook}
                  />
                </div>
              </div>

              <div className="form__form-group">
                <span className="form__form-group-label">{t('settings.onesignal.form_notification_body_length.label')}:</span>
                <div className="form__form-group-field">
                  <Field
                    name="onesignal_body_length"
                    component={renderInputField}
                    type="number"
                    value={blog.link_facebook}
                  />
                </div>
              </div>

              <div className="form__form-group">
                <span className="form__form-group-label">{t('settings.onesignal.form_notification_default_logo_url.label')}:</span>
                <div className="form__form-group-field">
                  <Field
                    name="onesignal_logo_url"
                    component={renderInputField}
                    type="text"
                    value={blog.link_facebook}
                  />
                </div>
              </div>

            </form>
            {/* <Collapse title="Learn more about OneSignal notifications">
              <p>No comfort do written conduct at prevent manners on. Celebrated contrasted discretion him sympathize
                    her collecting occasional. Do answered bachelor occasion in of offended no concerns. Supply worthy
                    warmth branch of no ye. Voice tried known to as my to. Though wished merits or be. Alone visit use
                    these smart rooms ham. No waiting in on enjoyed placing it inquiry. In no impression assistance
                    contrasted. Manners she wishing justice hastily new anxious. At discovery discourse departure objection
                    we. Few extensive add delighted tolerably sincerity her. Law ought him least enjoy decay one quick
                    court. Expect warmly its tended garden him esteem had remove off. Effects dearest staying now
                    sixteen nor improve.
              </p>
            </Collapse> */}
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default reduxForm({
  form: 'blog_settings', // a unique identifier for this form
  enableReinitialize: true
})(withTranslation('dashboard')(OnesignalNotifications));
